import React, { useState } from 'react';
import {Link, NavLink} from "react-router-dom";
import "./stylesheets/Navbar.css";
import logo from "./images/AD_full.png";
import { BrowserView, MobileView } from 'react-device-detect';

export const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false)
  return (
    <>
    <BrowserView>
        <nav>
        <Link to="/" className="title"><img src= {logo}/></Link>
        
        <ul>
            <li>
                <NavLink to="/about">About</NavLink>
            </li>
            <li>
                <NavLink to="/services">Services</NavLink>
            </li>
            <li>
                <NavLink to="/contact">Contact</NavLink>
            </li>
        </ul>
    </nav>
    </BrowserView>
    <MobileView>
        <nav className= "mobileNav">
        <Link to="/" className="title"><img src= {logo}/></Link>
        <div className="menu"
        onClick={() => {
            setMenuOpen(!menuOpen)
        }}>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <ul className={menuOpen ? "open" : ""}>
            <li>
                <NavLink to="/about" onClick={() => {
            setMenuOpen(!menuOpen)
        }}>About</NavLink>
            </li>
            <li>
                <NavLink to="/services" onClick={() => {
            setMenuOpen(!menuOpen)
        }}>Services</NavLink>
            </li>
            <li>
                <NavLink to="/contact" onClick={() => {
            setMenuOpen(!menuOpen)
        }}>Contact</NavLink>
            </li>
        </ul>
    </nav>
    </MobileView>
    </>
  )
}
